import { memo } from "react"
import { Handle, Position, Node, NodeProps } from "@xyflow/react"
import MoleculeStructure from "../../../../components/Data/MoleculeStructure";
// import TruncatedText from "../../../../components/Page/TruncatedText";
import { ReadAcrossDataType } from "../../page/IndividualReadAcrossPage";

type SurroundingNode = Node<{
    label: string,
    smiles: string,
    angle: number,
    radius: number,
    tanimoto: string,
    raData: ReadAcrossDataType,
    index: number,
    onOpenModal: (raData: ReadAcrossDataType, index: number) => void,
}, 'surrounding'>;

export default memo(({ data }: NodeProps<SurroundingNode>) => {
    return (
        <div
        style={{ width: `${data.radius * 2}px` }}
        className="group aspect-square flex flex-col justify-center items-center gap-2 relative"
        onClick={() => data.onOpenModal(data.raData, data.index)}
    >
            <div><MoleculeStructure smiles={data.smiles} width={data.radius * 2 * 0.75} height={data.radius * 2 * 0.75}/></div>
            <p style={{ maxWidth: `${data.radius * 2}px` }} className="group-hover:underline transition-all text-default truncate text-[12px] font-medium">
                {data.label}
            </p>
            <Handle
                type="target"
                position={Position.Left} // default
                style={{
                    position: 'absolute',
                    left: `${50 - 50 * Math.cos(data.angle)}%`,
                    top: `${50 - 50 * Math.sin(data.angle)}%`,
                    transform: 'translate(-50%, -50%)',
                    height: 0,
                    width: 0,
                    background: 'transparent',
                    border: 'none',
                }}
            />
        </div>
    )
})